/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationRequirementReasonType;

(function (ValidationRequirementReasonType) {
  ValidationRequirementReasonType["WARNING"] = "warning";
  ValidationRequirementReasonType["ERROR"] = "error";
  ValidationRequirementReasonType["INFO"] = "info";
})(ValidationRequirementReasonType || (ValidationRequirementReasonType = {}));